import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const templateCheckConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default templateCheckConfig;
